module.exports = __webpack_public_path__ + "static/media/transport.af978011.jpg";